module.exports = __webpack_public_path__ + "static/media/check-grey.85151b6d.svg";